(function () {
    'use strict';
    angular.module('app').controller('RoutingMatrixDetailsModalController', RoutingMatrixDetailsModalController);
    RoutingMatrixDetailsModalController.$inject = [
        '$uibModalInstance',
        'RoutingMatrixService',
        'toastr',
        'ConfirmationModalFactory',
        'id'
    ];

    function RoutingMatrixDetailsModalController(
        $uibModalInstance,
        RoutingMatrixService,
        toastr,
        ConfirmationModalFactory,
        id
    ) {
        const vm = this;
        vm.searchLocations = searchLocations;
        vm.onSubmit = onSubmit;
        vm.deleteRoute = deleteRoute;
        vm.closeModal = closeModal;
        vm.onSelect = onSelect;
        vm.onDelete = onDelete;
        vm.onDropComplete = onDropComplete;
        vm.onDragStart = onDragStart;
        vm.onDragStop = onDragStop;

        vm.isLoading = false;
        vm.locations = [];
        vm.filteredLocations = [];
        vm.routingMatrixData = {
            waypoints: []
        };

        const deleteConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.deleteRoutingMatrix.MESSAGE',
            code: 'messages.warning.deleteRoutingMatrix.CODE'
        });

        init(); 

        function init() {
            vm.id = id;
            if (vm.id) { getRouteData(); }
            getAvailableLocations();
        }

        function getRouteData() {
            RoutingMatrixService.routes.get(data => {
                vm.routingMatrixData = data;
            }, error => {
                toastr.error(error.message, 'Error');
            }, vm.id);
        }

        function getAvailableLocations() {
            RoutingMatrixService.locations.getAll(success => {
                const allowedOfficesTypes = ['Warehouse', 'Crossdock', 'ThirdPartyLogistics'];
                vm.locations = success.filter(loc => allowedOfficesTypes.indexOf(loc.officeType) !== -1);
            }, error => {
                toastr.error(error.message, 'Error');
            });   
        }

        function searchLocations(select) {
            vm.filteredLocations = [];

            const waypoints = removeAlreadySelectedWaypoints();
            const searchTerm = select.search;
            if (!searchTerm) { vm.filteredLocations = waypoints; }
           
            vm.filteredLocations = waypoints.filter(loc => loc.name.toLowerCase().includes(searchTerm.toLowerCase()));
        }

        function removeAlreadySelectedWaypoints() {
            const selectedIds = vm.routingMatrixData.waypoints.map(dat => dat.id);
            return vm.locations.filter(loc => selectedIds.indexOf(loc.id) === -1);
        }

        function onSelect(selected) {
            vm.routingMatrixData.waypoints.push(selected);
            vm.search = null;
        }

        function onDelete(waypoint) {
            const findIndex = vm.routingMatrixData.waypoints.findIndex(elem => elem.id === waypoint.id); 
            vm.routingMatrixData.waypoints.splice(findIndex, 1);
        }

        function onDropComplete(dragIndex, event, dropIndex) {
            const dragData = vm.routingMatrixData.waypoints[dragIndex];

            vm.routingMatrixData.waypoints.splice(dragIndex, 1);
            vm.routingMatrixData.waypoints.splice(dropIndex, 0, dragData);
        }

        function onDragStart(event) {
            angular.element(event.element).addClass('waypoints__items__ondrag');
        }

        function onDragStop(event) {
            angular.element(event.element).removeClass('waypoints__items__ondrag');
        }

        function onSubmit(form) {
            form.$setSubmitted();
            if (isFormInvalid(form)) { return; }

            if (vm.id) {
                update();
                return;
            }

            create();
        }

        function isFormInvalid(form) {
            if (form.$invalid) { return true; }
            return false;
        }

        function update() {
            vm.isLoading = true;
            RoutingMatrixService.routes.update(success => {
                toastr.success('Data updated', 'Success');
                vm.isLoading = false;
                $uibModalInstance.close();
            }, error => {
                toastr.error(error.message , 'Error');
                vm.isLoading = false;
            }, vm.routingMatrixData);
        }

        function create() {
            vm.isLoading = true;
            RoutingMatrixService.routes.create(success => {
                toastr.success('Data is saved', 'Success');
                vm.isLoading = false;
                $uibModalInstance.close();
            }, error => {
                toastr.error(error.message, 'Error');
                vm.isLoading = false;
            });
        }

        function deleteRoute() {
            deleteConfirmation.getInstance().result.then(cond => {
                if (cond) {
                    RoutingMatrixService.routes.delete(success => {
                        $uibModalInstance.close();
                        toastr.success('Routing matrix data deleted', 'Success');
                    }, error => {
                        toastr.error(error.message, 'Error');
                    }, vm.id);
                }
            });
        }

        function closeModal() {
            $uibModalInstance.close();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/routing-matrix/RoutingMatrixDetailsModalController.js